import { Button, Card, Divider } from 'antd';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BASEPRODUCTS, getProductsDetails, manageSubscriptions, purchase, TEACHERPRODUCTS } from '../../modules/subscription';

import { t } from '../../languages';
import { getMobileOperatingSystem, getTeachSubscriptionNumClasses, isValidActiveClient, userHasSubscription } from '../../utils';
import DragShaoesInOrder from '../gamez/dragshapesinorder';
import './index.less';
import WebSubscriptionButton from './WebSubscriptionButton';

const os = getMobileOperatingSystem().toLocaleLowerCase();
const _BASEPRODUCTS = BASEPRODUCTS[os];
const HASSUBSCRIPTION = false;
const MAXNUMCLASSES = 0;

const SubscriptionOptions = ({ lang, products, transactions, purchase, manageSubscriptions, getProductsDetails, user, forTeach = false }) => {
    // console.log('SubscriptionOptions: os::', os, '_BASEPRODUCTS::', _BASEPRODUCTS);

    const [selectedOption, setSelectedOption] = useState(_BASEPRODUCTS ? (forTeach ? _BASEPRODUCTS[3] : _BASEPRODUCTS[2]) : null);
    const [parentalOk, setParentalOk] = useState(os === 'ios' ? false : true);
    const [productsDetails, setProductsDetails] = useState(null);
    const [hasSubscription, setHasSubscription]: [any, any] = useState(HASSUBSCRIPTION);
    const [isActiveClient, setIsActiveClient]: [any, any] = useState(false);
    const [myPurchasedProducts, setMyPurchasedProducts]: [any, any] = useState(null);
    const [hasTeacherSubscription, setHasTeacherSubscription]: [any, any] = useState(HASSUBSCRIPTION);
    const [maxNumClasses, setMaxNumClasses]: [any, any] = useState(MAXNUMCLASSES);

    useEffect(() => {
        // console.log('SubscriptionOptions: products::', products, 'transactions::', transactions);
        // const os = getMobileOperatingSystem().toLocaleLowerCase();
        // if(os=='ios' && !products) loadSubscriptions();
        setProductsDetails(getProductsDetails());
    }, [products]);

    const evalHasSubscription = () => {
        const isActiveClient = isValidActiveClient(user);
        setIsActiveClient(isActiveClient);

        /* REAL */
        // let hasSubscription = (transactions && transactions.length > 0);
        let { hasSubscription, products } = userHasSubscription(transactions, user);

        /* test NO SUBSCRIPTIONS */
        // hasSubscription = false;

        /* test with SUBSCRIPTIONS */
        // hasSubscription = true;

        setHasSubscription(hasSubscription);
        setMyPurchasedProducts(products);

        const { hasTeacherSubscription, maxNumClasses } = getTeachSubscriptionNumClasses(products, TEACHERPRODUCTS[os]);
        setHasTeacherSubscription(hasTeacherSubscription);
        setMaxNumClasses(maxNumClasses);
    }

    useEffect(() => {
        evalHasSubscription();
    }, [transactions]);

    useEffect(() => {
        evalHasSubscription();
    }, [user]);

    const doPurchase = () => {
        // console.log('SubscriptionOptions.doPurchase:', selectedOption);
        if (products) for (const aProduct of products) {
            if (aProduct.id === selectedOption) {
                purchase(aProduct);
                break;
            }
        }
    }

    const getProductPrice = (id, defBase, defYear) => {
        // console.log('SubscriptionOptions.getProductPrice:', productsDetails);

        if (productsDetails && productsDetails[id] && productsDetails[id].pricing) {
            const basePrice = productsDetails[id].pricing.priceMicros / 1000000;
            const currency = productsDetails[id].pricing.currency;
            return {
                base: `${basePrice} ${currency}`,
                year: `${basePrice * 12} ${currency}`,
            };
        } else {
            return {
                base: defBase,
                year: defYear,
            };
        }
    }


    // console.log('SubscriptionOptions - forTeach:', forTeach, 'hasTeacherSubscription:', hasTeacherSubscription, 'hasSubscription:', hasSubscription);

    if (!forTeach && hasSubscription) {
        if (!window.cordova) return null;
        else return <Button onClick={manageSubscriptions} className="button-blue">{t(lang, 'managesubscription')}</Button>;
    } else {
        if (!window.cordova) {
            return <WebSubscriptionButton lang={lang} user={user} />;
        } else if (parentalOk) {
            const freetrial_url = lang === 'en' ? 'https://www.misoroban.com/try-free-3-days/' : 'https://www.misoroban.com/prueba-gratis-3-dias/';
            const termsandconditions_url = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';
            const privacypolicy_url = 'https://www.misoroban.com/privacidad/';

            let paymentDetail = t(lang, 'paymentDetailApple');
            // if (os !== 'ios') paymentDetail = paymentDetail.replace('iTunes', 'Google Play');

            const monthlyPrice = getProductPrice(_BASEPRODUCTS[0], '2€', '24€');
            const quaterlyPrice = getProductPrice(_BASEPRODUCTS[2], '5€', '20€');
            const yearlyPrice = getProductPrice(_BASEPRODUCTS[1], '12€', '12€');
            const monthlyTeachPrice = getProductPrice(_BASEPRODUCTS[3], '8€', '96€');
            const monthlyTeachPrice5 = getProductPrice(_BASEPRODUCTS[4], '20€', '240€');

            const TeacherCards = () => {
                return [<Card key={_BASEPRODUCTS[3]} onClick={() => setSelectedOption(_BASEPRODUCTS[3])} className={selectedOption === _BASEPRODUCTS[3] ? 'selected' : ''} title={t(lang, 'montlyteach')} bordered={false}>
                    <p>{monthlyTeachPrice.base} / {t(lang, 'month')}</p>
                </Card>,
                <Card key={_BASEPRODUCTS[4]} onClick={() => setSelectedOption(_BASEPRODUCTS[4])} className={selectedOption === _BASEPRODUCTS[4] ? 'selected' : ''} title={t(lang, 'montlyteach5')} bordered={false}>
                    <p>{monthlyTeachPrice5.base} / {t(lang, 'month')}</p>
                </Card>];
            };

            const ParentCards = () => {
                return [
                    <Card key={_BASEPRODUCTS[0]} onClick={() => setSelectedOption(_BASEPRODUCTS[0])} className={selectedOption === _BASEPRODUCTS[0] ? 'selected' : ''} title={t(lang, 'montly')} bordered={false}>
                        <p>{monthlyPrice.base} / {t(lang, 'month')} {/* - {monthlyPrice.year} / {t(lang, 'year')} */}</p>
                    </Card>,
                    <Card key={_BASEPRODUCTS[2]} onClick={() => setSelectedOption(_BASEPRODUCTS[2])} className={selectedOption === _BASEPRODUCTS[2] ? 'selected' : ''} title={t(lang, 'quaterly')} bordered={true}>
                        <p>{quaterlyPrice.base} / 3 {t(lang, 'months')} {/* - {quaterlyPrice.year} / {t(lang, 'year')} */}</p>
                    </Card>,
                    <Card key={_BASEPRODUCTS[1]} onClick={() => setSelectedOption(_BASEPRODUCTS[1])} className={selectedOption === _BASEPRODUCTS[1] ? 'selected' : ''} title={t(lang, 'yearly')} bordered={false}>
                        <p>{yearlyPrice.base} / {t(lang, 'year')}</p>
                    </Card>
                ];
            };



            return <section className={`subscription`}>
                <div className='icon'><img src={'./static/subscription/crown_w.svg'} alt={'crown'} /></div>

                <h3>{t(lang, forTeach ? 'createclassesandtournaments' : 'morethan25')}</h3>

                <p className="try">
                    <strong>{t(lang, 'try3days')}</strong><br />
                    {t(lang, 'onallplans')} {t(lang, 'cancelwhenyouwant')}
                </p>

                {forTeach ? null : [<ParentCards />, <br />]}

                {forTeach ? null : <span style={{ color: 'white' }}>{t(lang, 'areyouteacher')}</span>}
                {forTeach ? null : <h3>{t(lang, 'createclassesandtournaments')}</h3>}
                <TeacherCards />

                <Button onClick={() => doPurchase()} className="empezar button-blue">{t(lang, 'startnow')}</Button>

                {os === 'ios' ? <div>
                    <Divider style={{ background: 'white' }} />
                    <span style={{ color: 'white' }}>{t(lang, 'ifalreadysubscribed')}:</span><br />
                    <Button onClick={() => doPurchase()} className="restore">{t(lang, 'restorePurchases')}</Button>
                    <Divider style={{ background: 'white' }} />
                </div> : null}

                <p className='data'>
                    {t(lang, 'autorenewable')} {t(lang, 'cancelwhenyouwant')}
                </p>

                <p className='data'>
                    {os === 'ios' ? <span>
                        <a href={termsandconditions_url} target="subscription">{t(lang, 'termsandconditions')}</a>  |  <a href={privacypolicy_url} target="subscription">{t(lang, 'privacypolicy')}</a>
                    </span> : null}
                    <br />
                    {paymentDetail}
                    <br /> <br />
                    {t(lang, 'onlyfirstsubscription')}
                </p>
                <p className='data'>
                    <b>{t(lang, 'needmorecontact')} <a href="mailto:equipo@misoroban.com">equipo@misoroban.com</a></b>
                </p>
                <p className='data'>
                    <a href={freetrial_url} target="subscription">{t(lang, 'howfreetrialworks')}</a>
                </p>

            </section>;
        } else {
            return <section className="subscription">
                <DragShaoesInOrder lang={lang} params={null} uid={0} eid={0} saveResult={() => setParentalOk(true)} handleCancel={() => console.log('cancel')} />
            </section>;
        }


    }

};


const mapStateToProps = ({ user, subscription }) => ({
    user: user.user,
    version: user.app_version,
    lang: user.lang,
    products: subscription.products,
    transactions: subscription.transactions
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            purchase,
            manageSubscriptions,
            getProductsDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionOptions);
